module.exports = __webpack_public_path__ + "img/prince_15s_juillet2021.bddec317.jpg";